import { TextField } from '@mui/material';
import { InputProps } from './types';

export const Input: React.FC<InputProps> = ({
  disabled,
  hasError,
  errorText,
  onChange,
  onKeyPress,
  placeholder,
  label,
  value,
  variant = 'outlined',
  size,
  sx,
  inputLabelProps,
  multiline,
  InputProps,
  rows,
  name,
  dataTestId,
  onKeyDown,
  defaultValue,
  type,
}) => {
  return (
    <TextField
      type={type}
      label={value ? label : ''}
      defaultValue={defaultValue}
      name={name}
      value={value}
      disabled={disabled}
      error={hasError}
      fullWidth
      onChange={onChange}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      variant={variant}
      size={size}
      sx={sx}
      InputLabelProps={{
        ...inputLabelProps,
      }}
      multiline={multiline}
      rows={rows}
      helperText={hasError && errorText}
      InputProps={InputProps}
      inputProps={{
        'data-testid': dataTestId || 'mui-input',
      }}
      onKeyDown={onKeyDown}
    />
  );
};
